<script setup lang="ts">
defineProps<{
    name: string
    tiny?: boolean
    small?: boolean
    big?: boolean
    extraBig?: boolean
    accent?: boolean
    circle?: boolean
    success?: boolean
    error?: boolean
    highlight?: boolean
    light?: boolean
    inverted?: boolean
    hoverAccent?: boolean
}>();
const base = import.meta.env.BASE_URL;
</script>

<template>
    <svg
        class="kgr-icon"
        :class="[
            tiny && 'kgr-icon--tiny',
            small && 'kgr-icon--small',
            big && 'kgr-icon--big',
            extraBig && 'kgr-icon--extraBig',
            accent && 'kgr-icon--accent',
            circle && 'kgr-icon--circle',
            success && 'kgr-icon--success',
            error && 'kgr-icon--error',
            highlight && 'kgr-icon--highlight',
            light && 'kgr-icon--light',
            inverted && 'kgr-icon--inverted',
            hoverAccent && 'kgr-icon--hoverAccent',
        ]"
        aria-hidden="true"
    >
        <use :href="`${base}styleguide/icons.svg#${name}`" />
    </svg>
</template>
